export const SEARCH_QUERY_PARAMS = {
  SEARCH_TEXT: 'searchtext',
  FILTER: 'type',
  SORT: 'sortby'
};
